module.exports = __webpack_public_path__ + "2727e228deccc43952903d2b06951466.svg";